import React, { useCallback } from "react";
import { ReactComponent as SwitchImage } from "../../Assets/NotFound/switch.svg";
import ComputerImages from "../../Assets/NotFound/computer.svg";
import { GreenButton } from "../../Components/Button/CustomButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import "./NotFound.scss";
import Page from "../../Components/Dashboard/Page";

const NotFoundDashboard = () => {
  const navigate = useNavigate();
  const goBackToHome = useCallback(
    () => navigate("/", { replace: true }),
    [navigate]
  );
  return (
    <Page>
      Sorry this page does not exist, check your url properly or click on any item on the side bar sidebar menu
    </Page>
   
  );
};

export default NotFoundDashboard;
